import { useState } from 'preact/hooks';
import { gameRoute, parseLink } from '../../shared/links.ts';
import { listLibrary } from '../lib/library.ts';
import { navigate } from '../router.ts';
import { PLATFORM_NAMES } from '../format.ts';
import { LegalFooter } from './legal.tsx';

export function Home() {
  const [text, setText] = useState('');
  const [error, setError] = useState('');
  const recent = listLibrary();
  const open = (e: Event) => {
    e.preventDefault();
    const r = parseLink(text);
    if (!r.ok) { setError(r.error); return; }
    navigate(gameRoute(r.link));
  };
  return (
    <main class="home">
      <h1 class="brand"><img src="/logo.svg" alt="" width="40" height="40" />retrowser</h1>
      <p class="lead">Play web builds of game decompilations from their GitHub repositories, with your own ROM. The ROM never leaves this device.</p>
      <form onSubmit={open} class="paste">
        <label for="link">Game repository link</label>
        <div class="row">
          <input id="link" name="link" type="text" inputMode="url" autoComplete="off" spellcheck={false}
            placeholder="https://github.com/owner/repo" value={text}
            onInput={(e) => { setText((e.target as HTMLInputElement).value); setError(''); }} />
          <button type="submit">Open</button>
        </div>
        {error && <p class="field-error" role="alert">{error}</p>}
      </form>
      {recent.length > 0 && (
        <section>
          <h2>Recent games</h2>
          <ul class="library">
            {recent.map((e) => (
              <li key={e.key}>
                <a href={gameRoute(e.link)} onClick={(ev) => { ev.preventDefault(); navigate(gameRoute(e.link)); }}>{e.title}</a>
                <span class="muted"> · {PLATFORM_NAMES[e.platform] ?? e.platform} · {e.link.owner}/{e.link.repo}</span>
              </li>
            ))}
          </ul>
        </section>
      )}
      <p class="muted">Games follow the <a href="/spec">retrowser standard v1</a> (<code>retrowser.json</code>).
        Making a port? <a href="/docs">Make your project run on retrowser</a>.</p>
      <LegalFooter />
    </main>
  );
}
